<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 7081 7081"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
   <path :style="{fill: color}"
         d="M3540 0c-1955,0 -3540,1585 -3540,3540 0,1956 1585,3541 3540,3541 1956,0 3541,-1585 3541,-3541 0,-1955 -1585,-3540 -3541,-3540zm2406 4893l0 0c-41,39 -93,58 -145,58 -55,0 -109,-21 -150,-63l-1052 -1091 -822 0 0 800 986 1022c80,83 77,214 -5,294 -83,80 -215,78 -295,-5l-686 -711 0 599c0,115 -94,208 -209,208 -115,0 -208,-93 -208,-208l0 -662 -809 780c-40,39 -92,59 -144,59 -55,0 -110,-22 -150,-64 -80,-83 -78,-215 5,-295l1098 -1059 0 -758 -863 0 -1050 1013c-40,39 -92,58 -144,58 -55,0 -109,-21 -150,-64 -80,-83 -78,-214 5,-294l739 -713 -619 0c-115,0 -209,-93 -209,-208 0,-115 94,-209 209,-209l629 0 -755 -782c-80,-83 -78,-215 5,-295 83,-80 215,-77 295,6l1034 1071 874 0 0 -829 -1020 -1057c-80,-83 -78,-215 5,-294 83,-80 215,-78 295,5l720 746 0 -653c0,-115 93,-208 208,-208 115,0 209,93 209,208l0 649 775 -748c82,-80 214,-78 294,5 80,83 78,214 -5,294l-1064 1027 0 855 849 0 1029 -993c83,-80 215,-78 295,5 80,83 78,214 -5,294l-720 694 551 0c115,0 208,94 208,209 0,115 -93,208 -208,208l-598 0 773 801c80,83 77,215 -5,295z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'CoolingDevice',
  props: {
    color: {
      type: String,
      required: false,
      default: '#CCCCCC',
    },
  },
};
</script>

<style scoped>
.fil0 {
  fill: #1DAAE1;
  fill-rule: nonzero
}
</style>
